// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/css/base.css
// module id = +AMy
// module chunks = 0